import React from 'react';
import { Grid, Table, Loader, Dimmer, Segment } from 'semantic-ui-react';
import TablePaginationMenu from '../../../../components/TablePaginationMenu';

import { FormikProps } from 'formik';
import styled from 'styled-components';
import moment from 'moment-timezone';
import { formatAmount } from '../../../../services/masks';
import { FilterData } from '../../types';

const NotFoundWrapper = styled.div`
  width: 100%;
  text-align: center;
  color: #364445;
  font-size: 1.2em;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  padding: 1em;
  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15);
`;

const NotFoundMessage = styled.p`
  padding: 4.5px;
`;

interface ListData {
  data: any;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  page: number;
  setPage: (page: number) => void;
  total: number;
}

type Props = FormikProps<FilterData> & ListData;

const List = (props: Props) => {
  const { isLoading, data, setPage, total } = props;
  const dataList = data?.data;
  const setCurrentPage = (page: number) => {
    setPage(page);
  };

  return (
    <Grid>
      <Grid.Row columns="equal">
        <Grid.Column width={16}>
          {isLoading ? (
            <Dimmer.Dimmable as={Segment} dimmed={isLoading}>
              <Dimmer active={isLoading} inverted>
                <Loader />
              </Dimmer>
              <NotFoundWrapper />
            </Dimmer.Dimmable>
          ) : (
            <>
              {dataList && dataList.length > 0 ? (
                <Table celled>
                  <Table.Header fullWidth>
                    <Table.Row>
                      <Table.HeaderCell width={3}>SEGURADO</Table.HeaderCell>
                      <Table.HeaderCell width={2}>SEGURADORA</Table.HeaderCell>
                      <Table.HeaderCell width={2}>ENDEREÇO</Table.HeaderCell>
                      <Table.HeaderCell width={2}>TIPO DE RESTITUIÇÃO</Table.HeaderCell>
                      <Table.HeaderCell width={2}>VALOR DA RESTITUIÇÃO</Table.HeaderCell>
                      <Table.HeaderCell width={2}>DATA DE PAGAMENTO</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {dataList.map((item: any, index: number) => (
                      <Table.Row key={index}>
                        <Table.Cell>
                          {item?.bondInsurance?.naturalTenant
                            ? item?.bondInsurance?.naturalTenant?.main_tenant_name
                            : item?.bondInsurance?.legalTenant?.company}
                        </Table.Cell>
                        <Table.Cell>
                          {item?.bondInsurance?.bondInsuranceHiredData?.insurer?.name}
                        </Table.Cell>
                        <Table.Cell>{item?.bondInsurance?.property?.street}</Table.Cell>
                        <Table.Cell>Fiança</Table.Cell>
                        <Table.Cell>
                          R$ {formatAmount(Number(item.refundValue).toFixed(2))}
                        </Table.Cell>
                        <Table.Cell>
                          {item.refundDate
                            ? moment(item.refundDate).format('DD/MM/YYYY')
                            : '-'}
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                  <Table.Footer fullWidth>
                    <Table.Row>
                      <Table.HeaderCell colSpan={9} textAlign={'right'}>
                        {!isLoading && (
                          <TablePaginationMenu
                            currentPage={data?.page}
                            dataCount={total || 0}
                            setCurrentPage={setCurrentPage}
                          />
                        )}
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Footer>
                </Table>
              ) : (
                <NotFoundWrapper>
                  <NotFoundMessage>Registros não encontrados</NotFoundMessage>
                </NotFoundWrapper>
              )}
            </>
          )}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default List;
